import { useUrlParam } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { useNavigate } from "@opendash/router";
import { Flex, Tooltip, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { Project } from "../../../../../js/parsegenerated";
import { useProject } from "../../hooks/useProject";
import { ProjectDuedateIcon } from "./ProjectDuedateIcon";

type Props = {
  parent?: Project;
  style?: React.CSSProperties;
  styles?: {
    icon?: React.CSSProperties;
    text?: React.CSSProperties;
    back?: React.CSSProperties;
    duedate?: React.CSSProperties;
  };
};

export const ProjectTitle = observer((props: Props) => {
  const { project, icon, start, end } = useProject();
  const t = useTranslation();
  const nav = useNavigate();

  const [_, setActiveProject] = useUrlParam<string>(
    props.parent?.id,
    undefined
  ); // used to navigate back to parent project

  return (
    <Flex align="center" gap="small" style={props.style}>
      {props.parent && (
        <Tooltip
          title={t("maintenance:project.navigate.back", {
            project: props.parent.get("name"),
          })}
          color={props.parent?.get("color")}
        >
          <Icon
            icon="fa:chevron-left"
            style={{
              cursor: "pointer",
              ...props.styles?.back,
            }}
            onClick={() => setActiveProject(undefined)}
          />
        </Tooltip>
      )}
      <Tooltip title={t("maintenance:project.navigate.single")}>
        <Icon
          icon={icon}
          style={{ cursor: "pointer", ...props.styles?.icon }}
          onClick={() => nav("/openservice/project/" + project.id)}
        />
      </Tooltip>
      <Typography.Text style={props.styles?.text}>
        {project.get("name")}
      </Typography.Text>
      {(start || end) && <ProjectDuedateIcon style={props.styles?.duedate} />}
    </Flex>
  );
});
